/**
 * タグカラーの定数
 * 候補者タグと求人タグで共通で使用
 */
export const TAG_COLORS = [
  { name: 'グレー', value: '#F6F6F6', label: 'gray' },
  { name: 'ブルー', value: '#DFE4FF', label: 'blue' },
  { name: 'グリーン', value: '#E4FFF5', label: 'green' },
  { name: 'イエロー', value: '#FFFAE2', label: 'yellow' },
  { name: 'オレンジ', value: '#FFE5D9', label: 'orange' },
  { name: 'レッド', value: '#FFDBDD', label: 'red' },
  { name: 'マゼンタ', value: '#FFE2F9', label: 'magenta' },
  { name: 'パープル', value: '#EFE6FF', label: 'purple' },
];

export const COLOR_OPTIONS = TAG_COLORS.map((color) => ({
  value: color.label,
  label: color.name,
}));
